import React from 'react';
import { UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class MakePrivateProfile extends React.Component {

  static propTypes = {
    user: UserShape,
    onMakePrivate: PropTypes.func
  }

  render() {
    if (this.props.user.get('public')) {
      return this.renderMakePrivateProfileForm();
    } else {
      return this.renderYouAreNowPrivate();
    }
  }

  renderMakePrivateProfileForm() {
    return (
      <div className='make-public-profile'>
        <h2>Hide yourself and turn off following?</h2>
        <p>
          We will:
        </p>
        <ol>
          <li>Hide your profile so people can't see what words you're tacking.</li>
          <li>Turn off the ability for people to follow you.</li>
          <li>Turn off the ability for you to follow other people.</li>
        </ol>
        <div className='action'>
          <Link to='/account' className='btn btn-outline-secondary'>Nevermind</Link>
          <button onClick={ this.onMakePrivate.bind(this) } className='btn btn-dark' data-primary-cta='true'>Hide and Turn It Off</button>
        </div>
      </div>
    );
  }

  renderYouAreNowPrivate() {
    return (
      <div className='row public-profile-confirmation'>
        <div className='offset-sm-2 col-sm-8'>
          <p>
            { `Done. We've turned off Following and have hidden your profile.` }
          </p>
        </div>
        <div className='offset-sm-2 col-sm-8 action'>
          <Link to='/account' className='btn btn-dark'>Thanks</Link>
        </div>
      </div>
    )
  }


  onMakePrivate() {
    this.props.onMakePrivate(this.props.user);
  }
}



// WEBPACK FOOTER //
// ./src/components/make_private_profile.jsx